export default __webpack_public_path__ + "static/media/Inactive.97dfe0eb.svg";